import React from "react";
import {
  Inbox,
  FileText,
  BookOpen,
  Database,
  ArrowUpRight,
  FileCode2,
  Plus
} from "lucide-react";
export const AdminDashboard = ({
  currentUser,
  submissions,
  posts,
  pages,
  curriculum,
  settings,
  onNavigateTab,
  onStatusChange
}) => {
  const newSubmissionsCount = submissions.filter((s) => s.status === "new").length;
  const recentSubmissions = submissions.slice(0, 5);
  const totalViews = posts.reduce((acc, p) => acc + (p.views || 0), 0);
  return <div className="space-y-8">
      {
    /* Top Welcome Card */
  }
      <div className="bg-white p-6 sm:p-8 rounded-2xl border border-stone-200 shadow-xs flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-xs text-emerald-800 font-semibold mb-1">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            <span>Authenticated Session Active · MySQL Relational Schema Loaded</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-slate-900">
            Welcome, {currentUser.name}
          </h1>
          <p className="text-xs text-slate-500 mt-1">
            Role: <span className="font-bold text-slate-700 uppercase">{currentUser?.role ? currentUser.role.replace("_", " ") : "STAFF"}</span> · Campus: Tulatoli Bazar, Daganbhuiyan, Feni
          </p>
        </div>

        {
    /* Quick actions */
  }
        <div className="flex flex-wrap items-center gap-2">
          {currentUser.role !== "moderator" && <button
    onClick={() => onNavigateTab("posts")}
    className="px-3.5 py-2 text-xs font-bold text-white bg-emerald-800 hover:bg-emerald-900 rounded-lg transition-colors flex items-center gap-1.5 cursor-pointer"
  >
              <Plus className="w-3.5 h-3.5" />
              <span>New Blog Post</span>
            </button>}

          <button
    onClick={() => onNavigateTab("php_export")}
    className="px-3.5 py-2 text-xs font-semibold text-slate-700 bg-stone-100 hover:bg-stone-200 border border-stone-200 rounded-lg transition-colors flex items-center gap-1.5 cursor-pointer"
  >
            <FileCode2 className="w-3.5 h-3.5 text-amber-600" />
            <span>Export PHP & MySQL</span>
          </button>
        </div>
      </div>

      {
    /* Primary KPI Metrics */
  }
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {
    /* Metric 1: Inquiries */
  }
        <div
    onClick={() => onNavigateTab("submissions")}
    className="bg-white p-5 rounded-xl border border-stone-200 shadow-xs hover:border-emerald-600/40 transition-all cursor-pointer group"
  >
          <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
            <span>Admission Inquiries</span>
            <Inbox className="w-4 h-4 text-emerald-800" />
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-slate-900 tabular-nums">
              {submissions.length}
            </span>
            {newSubmissionsCount > 0 && <span className="text-[11px] font-bold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full">
                {newSubmissionsCount} new
              </span>}
          </div>
          <div className="mt-3 text-[11px] text-slate-400 flex items-center justify-between">
            <span>Requires moderation</span>
            <ArrowUpRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-emerald-800 group-hover:translate-x-0.5 transition-transform" />
          </div>
        </div>

        {
    /* Metric 2: Blog Posts */
  }
        <div
    onClick={() => onNavigateTab("posts")}
    className="bg-white p-5 rounded-xl border border-stone-200 shadow-xs hover:border-emerald-600/40 transition-all cursor-pointer group"
  >
          <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
            <span>Published Articles</span>
            <FileText className="w-4 h-4 text-blue-700" />
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-slate-900 tabular-nums">
              {posts.filter((p) => p.status === "published").length}
            </span>
            <span className="text-[11px] text-slate-500">
              ({posts.length} total)
            </span>
          </div>
          <div className="mt-3 text-[11px] text-slate-400 flex items-center justify-between">
            <span>{totalViews} readers reached</span>
            <ArrowUpRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-blue-700 group-hover:translate-x-0.5 transition-transform" />
          </div>
        </div>

        {
    /* Metric 3: Active Curriculum */
  }
        <div
    onClick={() => onNavigateTab("curriculum")}
    className="bg-white p-5 rounded-xl border border-stone-200 shadow-xs hover:border-emerald-600/40 transition-all cursor-pointer group"
  >
          <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
            <span>Curriculum Modules</span>
            <BookOpen className="w-4 h-4 text-teal-700" />
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-slate-900 tabular-nums">
              {curriculum.length}
            </span>
            <span className="text-[11px] text-emerald-700">Active</span>
          </div>
          <div className="mt-3 text-[11px] text-slate-400 flex items-center justify-between">
            <span>Noorani, Hifz & Primary</span>
            <ArrowUpRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-teal-700 group-hover:translate-x-0.5 transition-transform" />
          </div>
        </div>

        {
    /* Metric 4: MySQL Database Status */
  }
        <div
    onClick={() => onNavigateTab("database")}
    className="bg-white p-5 rounded-xl border border-stone-200 shadow-xs hover:border-emerald-600/40 transition-all cursor-pointer group"
  >
          <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
            <span>MySQL Schema Tables</span>
            <Database className="w-4 h-4 text-purple-700" />
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-slate-900 tabular-nums">
              7 Tables
            </span>
            <span className="text-[11px] text-purple-700">InnoDB UTF8mb4</span>
          </div>
          <div className="mt-3 text-[11px] text-slate-400 flex items-center justify-between">
            <span>Relational SQL Console</span>
            <ArrowUpRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-purple-700 group-hover:translate-x-0.5 transition-transform" />
          </div>
        </div>
      </div>

      {
    /* Recent Submissions Section */
  }
      <div className="bg-white rounded-2xl border border-stone-200 shadow-xs overflow-hidden">
        <div className="p-6 border-b border-stone-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <h2 className="text-lg font-bold text-slate-900">
              Recent Admission Inquiries & Messages
            </h2>
            <p className="text-xs text-slate-500 mt-0.5">
              Live submissions from the website contact and admission forms
            </p>
          </div>
          <button
    onClick={() => onNavigateTab("submissions")}
    className="text-xs font-semibold text-emerald-800 hover:text-emerald-950 flex items-center gap-1 cursor-pointer"
  >
            <span>View All ({submissions.length})</span>
            <ArrowUpRight className="w-3.5 h-3.5" />
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead className="bg-stone-50 border-b border-stone-200 text-slate-600">
              <tr>
                <th className="py-3 px-4 font-semibold">Date & Time</th>
                <th className="py-3 px-4 font-semibold">Applicant Name</th>
                <th className="py-3 px-4 font-semibold">Phone / WhatsApp</th>
                <th className="py-3 px-4 font-semibold">Class Applying</th>
                <th className="py-3 px-4 font-semibold">Status</th>
                <th className="py-3 px-4 font-semibold text-right">Moderation Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {recentSubmissions.map((sub) => <tr key={sub.id} className="hover:bg-stone-50/60 transition-colors">
                  <td className="py-3 px-4 text-slate-500 font-mono tabular-nums whitespace-nowrap">
                    {sub.created_at}
                  </td>
                  <td className="py-3 px-4 font-semibold text-slate-900">
                    <div>{sub.full_name}</div>
                    {sub.student_name && <span className="text-[11px] text-slate-500 font-normal">
                        Student: {sub.student_name} ({sub.student_age || ""} yrs)
                      </span>}
                  </td>
                  <td className="py-3 px-4 font-mono text-slate-700">
                    <a href={`tel:${sub.phone}`} className="hover:underline text-emerald-800">
                      {sub.phone}
                    </a>
                  </td>
                  <td className="py-3 px-4 text-slate-600">
                    {sub.class_applying || sub.subject}
                  </td>
                  <td className="py-3 px-4">
                    <span
    className={`inline-block px-2 py-0.5 text-[10px] font-bold rounded uppercase ${sub.status === "new" ? "bg-amber-100 text-amber-800" : sub.status === "reviewed" ? "bg-blue-100 text-blue-800" : sub.status === "contacted" ? "bg-emerald-100 text-emerald-800" : "bg-stone-100 text-slate-600"}`}
  >
                      {sub.status}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <div className="inline-flex items-center gap-1">
                      {sub.status === "new" && <button
    onClick={() => onStatusChange(sub.id, "reviewed")}
    className="px-2 py-1 text-[11px] bg-blue-50 hover:bg-blue-100 text-blue-700 rounded font-medium cursor-pointer"
  >
                          Mark Reviewed
                        </button>}
                      {sub.status !== "contacted" && <button
    onClick={() => onStatusChange(sub.id, "contacted")}
    className="px-2 py-1 text-[11px] bg-emerald-50 hover:bg-emerald-100 text-emerald-700 rounded font-medium cursor-pointer"
  >
                          Mark Contacted
                        </button>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Role-Based Access Guidance Card */
  }
      <div className="bg-stone-100 p-6 rounded-2xl border border-stone-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-slate-700 uppercase tracking-wider">
              Role Permissions Overview:
            </span>
            <span className="px-2 py-0.5 rounded text-[11px] font-bold bg-white text-emerald-900 border border-stone-200 uppercase">
              {currentUser.role}
            </span>
          </div>
          <p className="text-xs text-slate-600">
            {currentUser.role === "super_admin" && "You have unrestricted access to site pages, blog CRUD, user credentials, MySQL console, and PHP source exports."}
            {currentUser.role === "editor" && "You have permission to manage site pages, curriculum modules, and publish/draft blog posts."}
            {currentUser.role === "moderator" && "You have permission to review student inquiries and moderate contact form submissions."}
          </p>
        </div>

        {currentUser.role === "super_admin" && <button
    onClick={() => onNavigateTab("users")}
    className="px-4 py-2 text-xs font-semibold text-slate-800 bg-white hover:bg-stone-50 border border-stone-200 rounded-lg cursor-pointer shrink-0"
  >
            Manage User Roles (RBAC) &rarr;
          </button>}
      </div>
    </div>;
};
